exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!font-awesome/css/font-awesome.min.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n#hidden-print-div {\n    background-color: white;\n    width: 950px;\n    max-width: 950px;\n    margin: auto;\n    padding: 20px;\n    \n    top: 0px;\n    z-index: 1000;\n    /* position: absolute;*/\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/~/css-loader?{"sourceMap":false,"importLoaders":1}!A:/Work/Siti/Volpe2/~/postcss-loader?{"ident":"postcss"}!A:/Work/Siti/Volpe2/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2